<template>
  <div class="sitemap">
    <div class="auto_1280">
      <template v-if="lan === 0">
        <dl v-for="( item, index ) in menuList" :key="index">
          <dt><router-link :to="{ name: item.requestTo, query: { columnId: item.id } }">{{item.name}}</router-link></dt>
          <dd v-for="( inner, index ) in item.children" :key="index"><router-link :to="{ name: inner.requestTo, query: { columnId: item.id } }">{{inner.name}}</router-link></dd>
        </dl>
      </template>
      <template v-else-if="lan === 1">
        <dl v-for="( item, index ) in menuList" :key="index">
          <dt><router-link :to="{ name: item.requestTo, query: { columnId: item.id } }">{{item.enName}}</router-link></dt>
          <dd v-for="( inner, index ) in item.children" :key="index"><router-link :to="{ name: inner.requestTo, query: { columnId: item.id } }">{{inner.enName}}</router-link></dd>
        </dl>
      </template>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Sitemap',
  data () {
    return {
      menuList: [],
      lan: this.$store.state.isEn,
      articleTypeId: 34
    }
  },
  watch: {
    '$store.state.isEn' () {
      this.lan = this.$store.state.isEn
    }
  },
  mounted () {
    const self = this
    self.initId()
  },
  activated () {
    this.initId()
  },
  methods: {
    initId () {
      // const self = this
      // let menuList
      // try {
      //   menuList = JSON.parse(localStorage.getItem('routeList'))
      //   this.menuList = menuList
      // } catch (e) {
      //   console.log(e)
      // }
      // const id = parseInt(self.$route.query.columnId)
      // const index = self.$route.path.lastIndexOf('/')
      // const path = self.$route.path.substring(index + 1, self.$route.path.length)
      // menuList.forEach((item) => {
      //   if (id === item.id) {
      //     item.children.forEach((inner) => {
      //       if (inner.requestTo.toLowerCase() === path) {
      //         this.articleTypeId = inner.id
      //         this.$store.commit('changeId', inner.id)
      //       }
      //     })
      //   }
      // })
      this.$store.commit('changeId', this.articleTypeId)
      if (JSON.parse(localStorage.getItem('routeList')) === null) {
        let menuList = []
        this.$api.post('api/benefitArticleType/queryByParam', { current: 1, pageSize: 50 }, r => {
          r.data.forEach((item) => {
            let id
            if (item.parentId === 0) {
              menuList.push(item)
              id = item.id
              const children = []
              r.data.forEach((inner) => {
                if (inner.parentId === id) {
                  children.push(inner)
                }
              })
              menuList[menuList.length - 1].children = children
            }
          })
          this.menuList = menuList
        })
      } else {
        try {
          this.menuList = JSON.parse(localStorage.getItem('routeList'))
        } catch (e) {
          console.log(e)
        }
      }
    }
  }
}
</script>
<style scoped>
.sitemap{padding: 2% 0 5%;}
.sitemap dl{padding-bottom: 2%;}
.sitemap dt{font-size: 20px; line-height: 40px;}
.sitemap dd{margin-inline-start: 0; display: inline-block; line-height: 30px; margin-right: 2%;}
.sitemap dt a{color: #e4007f;}
.sitemap dd a{color: #333;}
</style>
